import { render, staticRenderFns } from "./StallholderSingleSelect.vue?vue&type=template&id=2b0c3bea&scoped=true"
import script from "./StallholderSingleSelect.vue?vue&type=script&lang=js"
export * from "./StallholderSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./StallholderSingleSelect.vue?vue&type=style&index=0&id=2b0c3bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c3bea",
  null
  
)

export default component.exports